






































import Vue from 'vue';

export default Vue.extend({
  props: [
    'link',
  ],
  data: () => ({
    dialog: false,
    snackbarShow: false,
    snackbarText: '',
    snackbarColor: '',
  }),
  methods: {
    copyLink() {
      const textToCopy = (this.$refs.container as Vue).$el.querySelector('input') as HTMLInputElement;
      textToCopy.select();
      const copied = document.execCommand('copy');
      if (copied) {
        this.showSnackbar('Link telah disalin', 'success');
      } else {
        this.showSnackbar('Tidak dapat menyalin link', 'error');
      }
    },
    showSnackbar(text: string, color: string) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbarShow = true;
    },
  },
});
